<div class="patient-preview">
  @if (currentRegModel()) {
    <div>
      <div class="columns">
        <div class="column is-6">
          <h3>Registration Details</h3>
          <table class="table is-fullwidth has-no-bottom-padding">
            <tbody>
              @if (currentRegModel().openTrackingNum) {
                <tr>
                  <td class="display-label">Open Tracking Id:</td>
                  <td>{{currentRegModel().openTrackingNum }}</td>
                </tr>
              }
              @if (!currentRegModel().openTrackingNum) {
                <tr>
                  <td class="display-label">Tracking Id:</td>
                  <td>{{currentRegModel().trackingNum }}</td>
                </tr>
              }
              @if (currentRegModel().assignedPatientId) {
                <tr>
                  <td class="display-label">Subject Id:</td>
                  <td>{{currentRegModel().assignedPatientId }}</td>
                </tr>
              }
              <tr>
                <td class="display-label">Assigned Arm:</td>
                <td>{{currentRegModel().assignedArm }}</td>
              </tr>
              @if (doseLevelVars.length > 0) {
                @for (eachVar of doseLevelVars ; track eachVar; let rowIdx = $index) {
                  <tr>
                    <td class="display-label">Dose Level</td>
                    <td>{{eachVar.nameValue}}</td>
                  </tr>
                }
              }
              @if (shouldDisplayTacTad()) {
                <tr>
                  <td class="display-label">TAC:</td>
                  <td>{{currentRegModel().tacTad.code}}</td>
                </tr>
              }
              @if (shouldDisplayTacTad()) {
                <tr>
                  <td class="display-label">TAD:</td>
                  <td>{{currentRegModel().tacTad.name}}</td>
                </tr>
              }
              @if (shouldDisplaySgc()) {
                <tr>
                  <td class="display-label">SGC:</td>
                  <td>{{currentRegModel().sgc.code}}</td>
                </tr>
              }
              @if (shouldDisplayAssignedKits()) {
                <tr>
                  <td class="display-label">Assigned Kits:</td>
                  <td>{{currentRegModel().doubleBlindResponse }} </td>
                </tr>
              }
              <tr>
                <td class="display-label">Enrollment Date:</td>
                <td> {{currentRegModel().enrollmentDate | date:'medium' }} </td>
              </tr>
              @if (currentRegModel().participatingRegSites) {
                <h3>Participation – Registration</h3>
                @for (item of currentRegModel().participatingRegSites; track item; let i = $index) {
                  <tr>
                    <td class="display-label">
                      <span>
                        {{item.name}}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{item.nameValue}}
                      </span>
                    </td>
                  </tr>
                }
              }
              @if (currentRegModel().participatingRegPersons) {
                @for (item of currentRegModel().participatingRegPersons; track item; let i = $index) {
                  <tr>
                    <td class="display-label">
                      <span>
                        {{item.name}}
                      </span>
                    </td>
                    <td>
                      {{item.nameValue}}
                    </td>
                  </tr>
                }
              }
              @if (currentRegModel().participatingSites.length>0) {
                <h3>Participation – Current</h3>
                @for (item of currentRegModel().participatingSites; track item; let i = $index) {
                  <tr>
                    <td class="display-label">
                      <span>
                        {{item.name}}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{item.nameValue}}
                      </span>
                    </td>
                  </tr>
                }
              }
              @if (currentRegModel().participatingPersons) {
                @for (item of currentRegModel().participatingPersons; track item; let i = $index) {
                  <tr>
                    <td class="display-label">
                      <span>
                        {{item.name}}
                      </span>
                    </td>
                    <td>
                      {{item.nameValue}}
                    </td>
                  </tr>
                }
              }
              <tr>
                <td colspan="2"></td>
              </tr>
            </tbody>
          </table>
          <h3>Subject Details</h3>
          <table class="table is-fullwidth has-no-bottom-padding">
            <tbody>
              <tr>
                <td class="display-label">
                  <span>Name</span>
                </td>
                <td class="">
                  @if (shouldDisplayLastName()) {
                    <span>
                      {{currentRegModel().lastName}}
                    </span>
                  }
                  @if (shouldDisplayFirstName()) {
                    <span>
                      {{currentRegModel().firstName}}
                    </span>
                  }
                  @if (shouldDisplayMiddleName()) {
                    <span>
                      {{currentRegModel().middleName}}
                    </span>
                  }
                </td>
              </tr>
              @if (shouldDisplayGender()) {
                <tr>
                  <td class="display-label">
                    <span>Gender</span>
                  </td>
                  <td class="">
                    <span>
                      {{currentRegModel().gender}}
                    </span>
                  </td>
                </tr>
              }
              @if (shouldDisplayRace()) {
                <tr>
                  <td class="display-label">
                    <span>Race</span>
                  </td>
                  @for (item of currentRegModel().races; track item; let i = $index) {
                    <td class="">
                      <span>
                        {{item}}
                      </span>
                    </td>
                  }
                </tr>
              }
              @if (shouldDisplayEthnicity()) {
                <tr>
                  <td class="display-label">
                    <span>Ethnicity</span>
                  </td>
                  <td class="">
                    <span>
                      {{currentRegModel().ethnicity}}
                    </span>
                  </td>
                </tr>
              }
              @if (shouldDisplayDOB()) {
                <tr>
                  <td class="display-label">
                    <span>Date of Birth</span>
                  </td>
                  <td class="">
                    <span>
                      {{currentRegModel().dateOfBirthString}}
                    </span>
                  </td>
                </tr>
              }
              @if (shouldDisplayZipCode()) {
                <tr>
                  <td class="display-label">
                    <span>Zip</span>
                  </td>
                  <td class="">
                    <span>
                      {{currentRegModel().zipCode}}
                    </span>
                  </td>
                </tr>
              }
              @if (shouldDisplayCountry()) {
                <tr>
                  <td class="display-label">
                    <span>Country</span>
                  </td>
                  <td class="">
                    <span>
                      {{currentRegModel().country}}
                    </span>
                  </td>
                </tr>
              }
              @if (shouldDisplayMedDra()) {
                <tr>
                  <td class="display-label">
                    <span>MED Dra</span>
                  </td>
                  <td class="">
                    <span>
                      {{currentRegModel().medDra}}
                    </span>
                  </td>
                </tr>
              }
              @if (shouldDisplayPaymentMethod()) {
                <tr>
                  <td class="display-label">
                    <span>Method of Payment</span>
                  </td>
                  <td class="">
                    <span>
                      {{currentRegModel().methodOfPayment}}
                    </span>
                  </td>
                </tr>
              }
              @if (shouldDisplayOtherSubjectId()) {
                <tr>
                  <td class="display-label">
                    <span>Other Subject ID</span>
                  </td>
                  <td class="">
                    <span>
                      {{currentRegModel().otherSubjectId}}
                    </span>
                  </td>
                </tr>
              }
              @if (shouldDisplayLinkedTo()) {
                <tr>
                  <td class="display-label">
                    <span>Linked To</span>
                  </td>
                  <td class="">
                    @for (item of currentRegModel().linkedSubjectIds ; track item; let isLast = $last) {
                      <span>
                        {{item}}{{isLast ? '' : ', '}}
                      </span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="column is-6">
          <h3>Study Details</h3>
          <table class="table is-fullwidth has-no-bottom-padding">
            <tbody>
              <tr>
                <td class="display-label">
                  <span>Study Number</span>
                </td>
                <td class="">
                  <span>
                    {{currentRegModel().studyNumber}}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="display-label">
                  <span>Long Description</span>
                </td>
                <td class="">
                  <span>
                    {{currentRegModel().studyDescription}}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="display-label">
                  <span>Schema Step</span>
                </td>
                <td class="">
                  <span>
                    {{currentRegModel().currentEventName}}
                  </span>
                </td>
              </tr>
              <tr>
                <td class="display-label">
                  <span>Version</span>
                </td>
                <td class="">
                  <span>
                    {{currentRegModel().versionNum}}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          @if (shouldDisplayEnrolledAncillaries()) {
            <div>
              <h3>Ancillary Registration(s)</h3>
              <table class="table is-fullwidth has-no-bottom-padding">
                <tbody>
                  @for (row of this.regPreview.enrolledAncillaries; track row) {
                    <tr>
                      <td class="display-label">
                        <span>
                          {{row.study.studyNumber}}:
                        </span>
                      </td>
                      <td>
                        <span>
                          {{row.study.longDescription}}
                        </span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
        <!-- shouldDisplayEnrolledAncillaries -->
      </div>
    </div>
  }
  @if (currentRegModel() && currentRegModel().patientForms) {
    <div>
      <!-- {{currentRegModel().formResponses | json}} -->
      @for (eachForm of currentRegModel().patientForms ; track eachForm; let formIdx = $index) {
        <div>
          <h3>
            {{eachForm.formName}}
          </h3>
          <table class="table is-striped is-fullwidth form-table ">
            <tbody>
              @for (row of eachForm.formVariables ; track row; let rowIdx = $index) {
                <tr>
                  <td class="has-left-padding">
                    <div class="columns">
                      <div class="column is-7  ">
                        @if (row && row.name) {
                          <div class="question-pad ql-editor" [innerHTML]="row.name| safeHtml">
                          </div>
                        }
                      </div>
                      <div class="column is-5 control">
                        <div>
                          {{row.nameValue}}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }